import { Role, applyAuthTokenHeader, clearLocalStorage, rolesManipulator } from 'auth';
import { Api as IdentityCenterApi } from 'identity-center-api';
import { get, isNumber } from 'lodash';
import {
  ENTITY_ID_SEARCH_PARAM_KEY,
  REGISTER_ID_SEARCH_PARAM_KEY,
} from '@/modules/common/constants/search-params.ts';
import { queryClient } from '@/modules/common/query.ts';
import { CURRENT_ENTITY_QUERY_KEY } from '@/modules/entity/queries/entity.tsx';
import { Api, GetEntityItemResponse } from 'api';

export const api = new Api({
  baseURL: import.meta.env.VITE_API_URL,
  validateStatus: status => status >= 200 && status < 300,
});

export const identityCenterApi = new IdentityCenterApi({
  baseURL: import.meta.env.VITE_IDENTITY_CENTER_API_URL,
  validateStatus: status => status >= 200 && status < 300,
});

identityCenterApi.instance.interceptors.request.use(applyAuthTokenHeader);

api.instance.interceptors.request.use(applyAuthTokenHeader);

api.instance.interceptors.request.use(
  rolesManipulator.apply_app_role_header.bind(rolesManipulator),
);

api.instance.interceptors.response.use(null, error => {
  const status: number = get(error, 'response.status');
  const url: string = get(error, 'config.url', '');

  if (status === 401 && /\/v1\/users$/.test(url)) {
    throw error;
  }

  if ([401, 419].includes(status)) {
    clearLocalStorage([]);
    queryClient.removeQueries();
    window.location.href = import.meta.env.VITE_APP_SELECTOR_URL;
  } else {
    throw error;
  }
});

api.instance.interceptors.request.use(config => {
  const entityResponse = queryClient.getQueryData<GetEntityItemResponse>([
    CURRENT_ENTITY_QUERY_KEY,
  ]);
  const registerId = new URLSearchParams(location.search).get(REGISTER_ID_SEARCH_PARAM_KEY); // here is desynchronization while using query data
  const entity_id = new URLSearchParams(location.search).get(ENTITY_ID_SEARCH_PARAM_KEY);
  if (
    entityResponse?.entity &&
    !config.headers['xEntity-ID'] &&
    rolesManipulator.current_user_role === Role.SR_INVESTOR
  ) {
    config.headers['xEntity-ID'] =
      !!entity_id && isNumber(+entity_id) ? entity_id : entityResponse?.entity?.id;
  }

  if (registerId && registerId !== 'all' && !('xRegister-ID' in config.headers)) {
    config.headers['xRegister-ID'] = registerId;
  }

  return config;
});
